<template>
  <div>
    <transition name="fade">
      <router-view :key="$route.fullPath"></router-view>
    </transition>
    <loading :show="loading" text="Por favor, aguarde..."></loading>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import Loading from "@/components/Loading";

export default {
  name: "EvasaoApp",
  components: {
    Loading
  },
  methods: {
    ...mapActions(["clearMessages"])
  },
  computed: {
    ...mapGetters(["loading"])
  }
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition-property: opacity;
  transition-duration: 0.25s;
}

.fade-enter-active {
  transition-delay: 0.25s;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue